export default "__VITE_ASSET__b1da0acd__"